import { useTenantStack } from '@Hooks';
import { useEffect } from 'react';

type SensorStatusCheckerReturn = void;

export const useTenantStackChecker = (): SensorStatusCheckerReturn => {
	const { tenantStackCheck } = useTenantStack();

	useEffect(() => {
		tenantStackCheck();
	}, []);
};
